export const getInterest = (debt: number): number =>
  debt > 0 ? Math.max(1, Math.round(debt / 10)) : 0;
